<template lang="pug">
  div
    div(v-if="enableUpload")
      el-col(v-if="showProgress", :span="4").right
        el-progress(:width=136, type="circle", :percentage="uploadPercent", style="margin-top: 40px; margin-left: 0px;")
      el-col(v-else, :span="4").right
        el-upload(
          :http-request="addAttachment",
          :action="''",
          :show-file-list="false",
          style="margin-left: 45px;",
          :disabled="isHistory"
          :class="['circle', {'history' : isHistory}]"
        ).circle
          img(v-if="photoData.photo" :src="photoData.photo", width="136px", height="136px").fit
          img(v-else, src="https://storage.healthathome.in.th/9dded22d-e32f-488a-bc29-d92859054dce.svg", width="136px", height="136px")
          .header-14-gray.overlayText(v-if="!isHistory") อัพโหลดรูป
    div(v-else)
      el-col(:span="4").right
        img(src="https://storage.healthathome.in.th/9dded22d-e32f-488a-bc29-d92859054dce.svg", width="136px", height="136px",style="margin-top: 40px;")
</template>

<style lang="scss" scoped>
  .circle {
    border-radius: 100%;
    height: 136px;
    width: 136px;
    justify-content: center;
    overflow: hidden;
    margin-top: 40px;
    margin-left: 40px;

    .history {
      .el-upload {
        cursor: default;
      }
    }
  }

  .right {
    text-align: right;
  }

  .fit {
    object-fit: cover;
  }

  .overlayText {
    position:relative;
    top: -85px;
    width:136px;
    height:30px;
    font-family: 'Sukhumvit-SemiBold';
    color: #D5D6DB;
    opacity:1;
  }
</style>
<style lang="scss">
  .circle {
    &.history {
      .el-upload {
        cursor: default !important;
      }
    }
  }
</style>

<script>
import { UploadImageHandler } from '../shared/UploadImageHandler'

export default {
  mixins: [UploadImageHandler],
  props: {
    photoData: {
      type: Object,
      required: true,
    },
    photoSetter: {
      type: Function,
      required: true,
    },
    enableUpload: {
      type: Boolean,
      required: false,
      default: false,
    },
    getCustomer: {
      type: Function,
      required: true,
    },
    isHistory: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    async addAttachment (upload) {
      if (!this.isImageAllowUpload(upload.file)) return
      try {
        this.showProgress = true
        const raw = await this.photoSetter(this.photoData.id, upload.file, this.onProgress)
        if (raw.downloadUrl) {
          this.photoData.photo = raw.downloadUrl
        }
        this.resetUploadProgress()
        this.getCustomer()
      } catch (error) {
        this.resetUploadProgress()
        this.$message.error(error)
      }
    },
    resetUploadProgress () {
      this.uploadPercent = 0
      this.showProgress = false
    },
  },
}
</script>
